import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;
export const TOKEN_KEY = "kanama_token";

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// ---- Storefront ----
export const fetchProducts = (category) =>
  client.get("/products", { params: category && category !== "All" ? { category } : {} }).then((r) => r.data);

export const fetchProduct = (slug) => client.get(`/products/${slug}`).then((r) => r.data);

export const createOrder = (payload) => client.post("/orders", payload).then((r) => r.data);

export const createCheckout = (payload) => client.post("/payments/checkout", payload).then((r) => r.data);

export const getPaymentStatus = (sessionId) => client.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const trackVisit = (path, referrer) =>
  client.post("/track/visit", { path, referrer }).catch(() => {});

export const submitContact = (payload) => client.post("/contact", payload).then((r) => r.data);

export const subscribeNewsletter = (email) => client.post("/newsletter", { email }).then((r) => r.data);

export const requestRestock = (slug, email) =>
  client.post(`/products/${slug}/notify-restock`, { email }).then((r) => r.data);

export const listReviews = (slug) =>
  client.get(`/products/${slug}/reviews`).then((r) => r.data);

export const createReview = (slug, payload) =>
  client.post(`/products/${slug}/reviews`, payload).then((r) => r.data);

// ---- Auth ----
export const registerUser = (payload) => client.post("/auth/register", payload).then((r) => r.data);
export const loginUser = (payload) => client.post("/auth/login", payload).then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);
export const getMyOrders = () => client.get("/auth/orders").then((r) => r.data);

// ---- Admin (JWT admin required; token attached by interceptor) ----
export const fetchVisits = (limit = 50) =>
  client.get("/admin/visits", { params: { limit } }).then((r) => r.data);

export const fetchVisitStats = () =>
  client.get("/admin/visits/stats").then((r) => r.data);

export const fetchOrders = (limit = 100) =>
  client.get("/admin/orders", { params: { limit } }).then((r) => r.data);

export const fetchOrderStats = () =>
  client.get("/admin/orders/stats").then((r) => r.data);

export const updateOrderStatus = (id, fulfillment_status) =>
  client.patch(`/admin/orders/${id}`, { fulfillment_status }).then((r) => r.data);

export const fetchAdminProducts = () =>
  client.get("/admin/products").then((r) => r.data);

export const updateProductStock = (slug, inStock) =>
  client.patch(`/admin/products/${slug}`, { inStock }).then((r) => r.data);

export const fetchAdminReviews = () =>
  client.get("/admin/reviews").then((r) => r.data);

export const deleteReview = (id) =>
  client.delete(`/admin/reviews/${id}`).then((r) => r.data);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
